export default function Loader() {
	return (
		<div className="loader lds-ring">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	);
}
